<template>
  <v-flex>
    <div>
      <Header />
      <GmapMap
        ref="myMap"
        v-if="bandera == 1"
        :center="myCoordinates"
        :zoom="zoom"
        map-type-id="roadmap"
        style="width: 100%; height: 100%; position: absolute; top: 0"
        :options="{
          gestureHandling: 'greedy',
          fullscreenControlOptions: {
            position: 9
          },
          mapTypeControlOptions: {
            position: 9
          }
        }"
      >
        <GmapMarker
          ref="markerOne"
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="true"
          :icon="markerOptions"
          @click="toggleInfoWindow(m, index)"
        />

        <GmapMarker
          ref="markerTwo"
          :key="indexUser"
          v-for="(mUser, indexUser) in markerUser"
          :position="mUser.position"
          :clickable="true"
          :icon="markerUserOptions"
          @click="toggleInfoWindowUser(mUser, indexUser)"
        />
        <GmapInfoWindow
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen = false"
        >
          <div v-html="infoContent"></div>
        </GmapInfoWindow>
        <GmapInfoWindow
          :options="infoOptionsUser"
          :position="infoWindowPosUser"
          :opened="infoWinOpenUser"
          @closeclick="infoWinOpenUser = false"
        >
          <div v-html="infoContentUser"></div>
        </GmapInfoWindow>
        <DireccionRender
          travelMode="DRIVING"
          :origin="origin"
          :destination="destination"
        />
      </GmapMap>
    </div>
    <v-container v-if="bandera == 2">
      <v-row align="center" justify="center">
        <v-col cols="12" md="3">
          <div class="d-flex flex-column justify-space-between align-center">
            <v-img src="@/assets/logo.jpg" width="150" height="150" contain />
            <p class="font-weight-bold text-center">ASISTENCIA FINALIZADA</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="bandera == 0">
      <v-row align="center" justify="center">
        <v-col cols="12" md="3">
          <div class="d-flex flex-column justify-space-between align-center">
            <v-img src="@/assets/logo.jpg" width="150" height="150" contain />
            <p class="font-weight-bold text-center">CARGANDO...</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-flex>
</template>

<script>
import { dbRefName, geofireRef } from "../main";
import Header from "../components/Header.vue";
import DireccionRender from "./DireccionRender";

const mapMarker = require("../assets/marker_proveedor.png");
const userMarker = require("../assets/iconGPSuser.png");
const imgProveedor = require("../assets/logo.jpg");

export default {
  components: {
    Header,
    DireccionRender
  },
  data() {
    return {
      myCoordinates: {
        lat: 0,
        lng: 0
      },
      zoom: 14,
      markers: [],
      markerUser: [],
      markerOptions: {
        url: mapMarker,
        size: { width: 43, height: 59, f: "px", b: "px" },
        scaledSize: { width: 43, height: 59, f: "px", b: "px" }
      },
      markerUserOptions: {
        url: userMarker,
        size: { width: 43, height: 59, f: "px", b: "px" },
        scaledSize: { width: 43, height: 59, f: "px", b: "px" }
      },
      bandera: 0,
      infoPosition: null,
      infoPositionUser: null,
      infoOpened: false,
      infoOpenedUser: false,
      infoContent: null,
      infoContentUser: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      infoOptionsUser: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWindowPosUser: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      infoWinOpenUser: false,
      currentMidx: null,
      currentMidxUser: null,
      Driver: null,
      imageDriver: "",
      nameDriver: null,
      namePlate: null,
      start: "",
      end: ""
    };
  },

  created() {
    this.urlDriver();
  },
  computed: {
    origin() {
      if (!this.start) return null;
      return { query: this.start };
    },
    destination() {
      if (!this.end) return null;
      return { query: this.end };
    }
  },
  beforeMount() {
    //this.moveCamera();
  },
  methods: {
    urlDriver() {
      let url = this.$route.params.id;
      let urlSeparating = url.split("~");
      this.Driver = urlSeparating[0]; //ID conductor
      this.codeDriverurl = urlSeparating[1]; //code conductor
      dbRefName.child(this.Driver).on("value", snapchop => {
        let code = snapchop.val().code;
        if (code == this.codeDriverurl) {
          this.initGeoFire(this.Driver, this.codeDriverurl);
          this.bandera = 1;
        } else {
          this.bandera = 2;
        }
      });
    },
    initGeoFire(Driver, codeDriverBD) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          this.myCoordinates = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          var lat = position.coords.latitude;
          var lng = position.coords.longitude;

          var url = this.$route.params.id;
          var urlSeparating = url.split("~");
          var Driver = urlSeparating[0];

          this.markerUser.push({
            name: "Mi posición",
            iconMarker: userMarker,
            position: {
              lat: lat,
              lng: lng
            }
          });

          var query = geofireRef.query({
            center: [lat, lng],
            radius: 170
          });
          query.on("key_entered", (key, location, distance) => {
            const dataName = dbRefName.child(key);

            dataName.on("value", snapshop => {
              this.nameDriver = snapshop.val().name;
              this.namePlate = snapshop.val().vehiclePlate;
              if (snapshop.val().img || this.Driver == key) {
                this.imageDriver = snapshop.val().image;
              } else {
                this.imageDriver = require("../assets/logo.jpg");
              }
              if (Driver === key) {
                this.markers.push({
                  key: key,
                  image: this.imageDriver,
                  name: this.nameDriver,
                  plate: this.namePlate,
                  iconMarker: mapMarker,
                  position: {
                    lat: location[0],
                    lng: location[1]
                  }
                });
              }
            });
          });
          query.on("key_exited", (key, location, distance) => {
            for (var i = 0; i < this.markers.length; i++) {
              if (this.markers[i].key == key) {
                this.markers.splice(i, 1);
              }
            }
          });
          query.on("key_moved", (key, location, distance) => {
            const dataName = dbRefName.child(key);
            dataName.on("value", snapchop => {
              var code = snapchop.val().code;
              if (code == codeDriverBD) {
                for (var i = 0; i < this.markers.length; i++) {
                  if (this.markers[i].key == key) {
                    var updatePosition = {
                      lat: location[0],
                      lng: location[1]
                    };
                    this.markers[i].position = updatePosition;
                    this.moveCamera(location);
                  }
                }
              }
            });
          });
        });
      }
    },
    moveCamera(positionProvider) {
      let me = this;
      me.$refs.myMap.panTo({
        lat: positionProvider[0],
        lng: positionProvider[1]
      });
    },
    toggleInfoWindowUser: function(markerUser, idxUser) {
      this.infoWindowPosUser = markerUser["position"];
      this.infoContentUser = this.getInfoWindowContentUser(markerUser);
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidxUser == idxUser) {
        this.infoWinOpenUser = !this.infoWinOpenUser;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpenUser = true;
        this.currentMidxUser = idxUser;
      }
    },
    toggleInfoWindow: function(marker, idx) {
      this.infoWindowPos = marker["position"];
      this.infoContent = this.getInfoWindowContent(marker);
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    getInfoWindowContentUser: function(markerUser) {
      return `<div class="card">
                <div class="card-content">
                  <p style="padding: 0px; margin: 0px;">${markerUser.name}</p>
                </div>
              </div>`;
    },
    getInfoWindowContent: function(marker) {
      return `<div class="card">
                <div style="text-align: center;">
                  <img src="${marker.image}" style="width: 100px; height: 100px;"/>
                  <p style="padding: 0px; margin: 0px; font-weight: bold; font-size: 20px;">Nombre: ${marker.name}</p>
                  <p style="padding: 0px; margin: 0px; font-weight: bold; font-size: 20px;">Placa: ${marker.plate}</p>
                </div>
              </div>`;
    }
  }
};
</script>

<style scoped></style>
